module.exports = {
  message: {
    hello_world: 'Hello World'
  },
  down: {
      grid_bot: 'A Crypto Grid Trading Bot',
      overcome_emotional: 'Overcome emotional investing',
      fortune_market: 'Make a fortune in both bull and bear markets',
      contact_email: 'Contact us',
      copy_success: 'Success',
      copy_failed: 'Copy failed',
      press_copy: 'Long press to copy',
			overseas: 'Need US/HK ',
			register_guide: 'Guidelines for Registering US ID',
			recommend:'recommend',
			enterprise:'enterprise',
  },
  sign: {
      register_id: 'Register',
      mobile_regist: 'Phone',
      email_regist: 'Email',
      input_phone: 'Please enter your phone number',
      input_email: 'Please enter your email adress',
      set_password: 'Please set the password',
      password_rule: '8-16 digit number and letter combination',
      password_warn: 'Both numbers and letters, between 8-16',
      invite_code: 'Referrer Code',
      agree: 'I have read and agree to the ',
      user_agr: 'User Agreement',
      privacy_agr: 'the Privacy Agreement',
      and: ' and ',
      regist: 'Register',
      agree_warn: 'Please read and agree to the terms first',
      already_regist: 'Registered? Click to download',
      phone_warn: 'Wrong phone number, please fill in again',
      email_warn: 'Wrong email, please fill in again',
      input_code: 'Enter the verification code',
      code_sended: 'Verification code sent to：',
      re_get: ' later will resend',
      regist_success: 'Congratulations on your registration!',
      down_app: 'Download App',
      user_exists: 'User already exists',
      resend: 'Resend',
      wrong_code: 'Wrong verification code',
      choose_area: 'Select Country/Region',
      search: 'Search',
  },
  common: {
    jgz: 'J Golden Zone',
    jgz_down: 'Download',
    invite_regist: 'Invite friend to register',
    open_in_browser: 'Open in Browser',
    jgz_team: 'JGZ Team',
    refresh: 'Click to Reload',
  },
  invite: {
    scan_down: 'Scan to download',
    invite_code: 'Referrer Code',
    invite: 'Invite Now',
    not_apple: 'This activity is not related to Apple',
    invite_friend: 'Invite friends',
    get_bot: 'Get trading bots now'
  },
  activity: {
    jgz_activity: 'JGZ Activity',
    failed: 'Oops！Failed to get data。',
    course: 'Course',
  },
  alarm: {
    how: 'How to add alert?',
    way: 'When you logged in,open any trading pair K-line page and click the Alert button to add a price alert.'
  }
}
